import { AgentCommands, UsedCommandType } from '~/constants/commands'
import { isAgentInternalStatus } from '~/constants/task-status'
import { AgentTaskStatus, commandTypeFromJSON } from '~/protos/agents'
import { useTaskAwareMetadata, useTaskAwareObj } from '../useTaskAware'
import { useTaskStatus } from './useTaskStatus'
import { useTerminatedStatus } from './useTerminatedStatus'

export function useTaskProgress() {
  const task = useTaskAwareObj()
  const taskStatus = useTaskStatus()
  const { command } = useTaskAwareMetadata()
  const isTerminatedStatus = useTerminatedStatus()

  if (isTerminatedStatus) {
    return 100
  }

  if (AgentTaskStatus.DOCUMENT_UPDATED === taskStatus) {
    return 50
  }

  const commandType = commandTypeFromJSON(command)

  const agentCommand = commandType ? AgentCommands[commandType as UsedCommandType] : null
  if (!agentCommand) {
    return 0
  }

  const { steps } = agentCommand
  const responses = task?.details?.orderedStateResponses
  if (Array.isArray(responses)) {
    const uniqueStatuses = new Set(
      responses.map(response => {
        if (isAgentInternalStatus(response.taskStatus)) {
          const { agentInternalStatus } = response.response[0].responseContentStream!
          return `${response.taskStatus}:${agentInternalStatus}`
        }
        return response.taskStatus
      })
    )

    if (uniqueStatuses.size > steps.length) {
      return 99
    }
    return Math.ceil((uniqueStatuses.size / steps.length) * 100)
  }
  return 0
}
